import { APICallV3Post } from 'reactApp/api/APICall';

type SubscriptionBuyResponse = { pw: string };

export class SubscriptionBuyAPICall extends APICallV3Post<SubscriptionBuyResponse> {
    _method = 'billing/subscription/buy';
}
